import React, { useState, useEffect } from 'react';
import { Box, Fab, Fade, Grid, Skeleton } from '@mui/material';
import { getMaterials } from '../../services/material-services';
import MatShowItem from './mat-show';
import PaginationControlled from './mat-pagination';
import { Link, useLocation, useParams } from 'react-router-dom';
// import Mata_Tags from '../layout/meta-tags';
import PropTypes from 'prop-types';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useFetchListGroup } from '../../hooks/fetchs-material';
import { useAuth } from '../../hooks/useAuth';
import MatShowHorizintalItem from './mat-show-horizintal';
import { Helmet } from 'react-helmet';

// export default useDeviceSize ;
function ScrollTop({ children }) {
  // const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window. برومند
  // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
      target: window ,
      disableHysteresis: true,
      threshold: 100,
    });

    const handleClick = (event) => {
      
        const anchor = (event.target.ownerDocument || document).querySelector(
          '#back-to-top-anchor',
        );
        if (anchor) {
          anchor.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
            top: 0, left: 0
          });
        }
    };

    return (
      <Fade in={trigger} >
        <Box
          onClick={(e) => handleClick(e)}
          role="presentation"
          sx={{ position: 'fixed', bottom: 160, left: 16 }}
        >
          {children}
        </Box>
      </Fade>
    );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  // window: PropTypes.func,
};

function MaterialList({dataMain}) {
    const { setAuthGroup, authDataGroup, authDataLang } = useAuth()
    // console.log(dataMain);
    
    
    const { type } = useParams()
    const location = useLocation()
    const { state } = location
    // const [searchParams] = useSearchParams();
    // const search = searchParams.get("search");
    const [searchData, setSearchData] = useState('')
    
    const [materials, setMaterilas] = useState(dataMain)
    const [error, setError] = useState(false)
    const [loading, setLoding] = useState(false)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const [showPagin, setShowPagin] = useState(false)
    const [ dataGroup, dataLoading, dataError ] = useFetchListGroup(authDataLang?.id, type)
    // const [ dataLang, langLoading, langError ] = useFetchLang('');
    // const [ dataCountry, countryLoading, countryError ] = useFetchCountry();
    // const [addloading, setAddLoading] = useState(false);

    
    const numRows = 10
    const isMobile = window.innerWidth <= 1000
        
    useEffect(()=>{
      setMaterilas(dataMain)
    }, [dataMain])

    useEffect(()=>{
      
        // window.scrollTo(0, 0)
        if(!authDataGroup){
            if(dataGroup){
                setAuthGroup(dataGroup[0])
            }
        }
        let resStr = ''
        if(state){
            if(state?.searchData){
                resStr = resStr + `&search_data=${state?.searchData}`
            }
        }
        if(type){
            resStr = resStr + `&type_data=${type}`
            // setAuthGroup(dataGroup[0]);
        }else{
            if(authDataGroup)
            {
                resStr = resStr + `&type_data=${authDataGroup?.name}`;
            }
        }
        setSearchData(resStr)
        const getData = async() =>{
          // setLoding(true);
            await getMaterials(page, numRows, resStr, authDataLang?.id)
            .then(data => {
                setMaterilas(data?.results)
                // const numRows = materials.results.length;
                const totalP = data.count / numRows
                const totalPTranc = Math.trunc(totalP)
                
                setTotalPage(totalPTranc)
                if((totalPTranc < totalP) & (totalPage > 1)){
                  setTotalPage(totalPTranc + 1)
                  setShowPagin(true)
                }
                
                if(totalPage > 1){
                  setShowPagin(true)
                }
                
                setLoding(false)
                setError(false)
            }).catch( e => {
                setError(true)
                setLoding(false)
            })
        }
        if(resStr)
        {
          getData()
        }

    }, [state, authDataGroup, setSearchData, authDataLang, totalPage])

    const handleClose = (value) => {
        
        setPage(value)
        window.scrollTo(0, 0)
        
        setLoding(true)
        const getData = async() =>{
          await getMaterials(value, numRows, searchData, authDataLang?.id)
          .then(data => {
            setMaterilas(data?.results)
            
            const totalPTranc = Math.trunc(data.count / numRows)
            const totalP = (data.count / numRows)
            setTotalPage(totalPTranc)
            if(totalPTranc < totalP){
              setTotalPage(totalPTranc + 1)
              setShowPagin(true)
            }

            if(totalPage > 1){
              setShowPagin(true)
            }
            setLoding(false)
            setError(false)
          }).catch( e => {
            setError(true)
            setLoding(false)
          })
        }
        getData()
        
    };

    setTimeout(function(){ 
        var hash_tag = window.location.hash
        let flagAction = 0
        if(hash_tag){
            if(hash_tag.length > 5)
            {
                const anchor = document.querySelector(
                    hash_tag,
                    );
                    // const anchor = document.getElementById(hash_tag.substring(1));
                    if (anchor) {
                        flagAction = 1;
                        anchor.scrollIntoView({
                            block: 'center',
                            behavior: 'smooth',
                            top: 0, left: 0
                        });
                    }
            }
        }
        if(flagAction === 0){
            window.scrollTo(0, 0)
        }
    }, 500)


  return (
    <React.Fragment>
        <Helmet>
            <title>صفحه اصلی | اِتک (ETEC)</title>
            <meta name="description" content="ETEC.IR بستری نوین برای آموزش، فناوری و توسعه مهارت‌های دیجیتال در ایران." />
            <meta name="keywords" content="ETEC, آموزش, فناوری, مهارت‌های دیجیتال, ایران, آموزش آنلاین" />
            <meta name="robots" content="index, follow" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta http-equiv="Content-Language" content="fa" />
            <meta name="author" content="ETEC.IR" />

            {/* Open Graph / Facebook */}
            <meta property="og:title" content="ETEC.IR | سامانه آموزش و فناوری" />
            <meta property="og:description" content="ETEC.IR بستری نوین برای آموزش، فناوری و توسعه مهارت‌های دیجیتال در ایران." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://etec.ir" />
            <meta property="og:image" content="https://etec.ir/static/images/og-image.jpg" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="ETEC.IR | سامانه آموزش و فناوری" />
            <meta name="twitter:description" content="ETEC.IR بستری نوین برای آموزش، فناوری و توسعه مهارت‌های دیجیتال در ایران." />
            <meta name="twitter:image" content="https://etec.ir/static/images/twitter-card.jpg" />
        </Helmet>

      <div style={{width: '100%', minHeight: 1000}}>
        {/* <test/> */}
          <Link id='back-to-top-anchor' />
          
          {/* {authDataGroup &&
              <Mata_Tags tags={authDataGroup}/>
          } */}
          {loading ?
              <Box sx={{ width: '100%' }}>
                  <Skeleton />
                  <Skeleton variant="rectangular" width='100%' height={300} />
                  <Skeleton animation="wave" />
                  <Skeleton animation={false} />
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton variant="rounded" width='100%' height={150} />
              </Box>
          :
              <div >

                <Grid 
                    container 
                    rowSpacing={3} 
                    columnSpacing={3} 
                    sx={isMobile ? {textAlign:'center'} : {textAlign:'left'}} 
                  >
                    { materials && materials.map( mat => {
                        return (
                            <Grid
                                key={mat.id}
                                item 
                                xs={12} 
                                sx={isMobile ? {textAlign:'center'} : {textAlign:'left'}} 
                              >
                                {isMobile ?
                                    <MatShowItem MatList={mat} /> 
                                :  
                                    <MatShowHorizintalItem MatList={mat} />
                                }
                            </Grid>
                          )
                    })}
                </Grid>

                <ScrollTop >
                  <Fab size="small" aria-label="scroll back to top" color="secondary">
                    <KeyboardArrowUpIcon />
                  </Fab>
                </ScrollTop>

                {showPagin &&
                  <div style={{width: '100%', display: 'block', textAlign: 'center'}}>
                      <br/><hr/><br/>
                      <PaginationControlled onChange={handleClose} pageNow={page} totalCount={totalPage}/>
                      {/* <PaginationControlled onPageChange={handleClose} page={page} count={totalPage} rowsPerPage={totalPage}/> */}
                  </div>
                }
              </div>
        }
      </div>

    </React.Fragment>
  );
}

export default MaterialList;
